export default "__VITE_ASSET__BXq_tgcg__"